import React from "react";
import "./AboutSection.css";
import BuildingImage from "../../assets/Home-about.png";

const AboutSection = () => {
  return (
    <section className="cm-about-section">
      <div className="cm-about-grid">
        
        {/* LEFT SECTION */}
        <div className="cm-about-left">
          <img src={BuildingImage} alt="Building" className="cm-left-bg" />
          <div className="cm-left-overlay">
            <h2 className="cm-left-text">
              Established<br />in<br />2019
            </h2>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="cm-about-right">
          <h3 className="cm-subtitle">About</h3>
          <h2 className="cm-title">CM Group of Companies</h2>

          <p className="cm-text">
            The CM Group of Companies was established in 2019 with a singular,
            powerful belief: that the most impactful and sustainable solutions
            arise from integrated success. We are not a company of siloed
            divisions; we are a strategic connector, expertly bringing together
            the worlds of strategic real estate and pioneering energy.
          </p>

          <p className="cm-text">
            This integrated approach allows us to deliver robust and comprehensive
            solutions built on environmental responsibility. We provide essential
            infrastructure—from the ground up to the power source—ensuring our
            projects are set up for long-term success.
          </p>

          <h3 className="cm-heading">Strategic Land Development</h3>
          <p className="cm-text">
            We have successfully delivered a total of <strong>600 acres of critical land</strong>,
            enabling significant development and investment opportunities.
          </p>

          <h3 className="cm-heading">Sustainable Power Generation:</h3>
          <p className="cm-text">
            Our commitment to the future is highlighted by the successful
            installation of a <strong>150 MW Solar Power Plant</strong>, a landmark achievement in
            renewable energy.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
